import { render, staticRenderFns } from "./GoodsSelector.vue?vue&type=template&id=31647c1a&scoped=true&"
import script from "./GoodsSelector.vue?vue&type=script&lang=js&"
export * from "./GoodsSelector.vue?vue&type=script&lang=js&"
import style0 from "./GoodsSelector.vue?vue&type=style&index=0&id=31647c1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31647c1a",
  null
  
)

export default component.exports